import { Popover } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import React, { useState, MouseEvent } from 'react';
import { IAlert } from '../../../models/common';
import { IPHRequest } from '../../../models/purchase-history';
import QuickBooksModal from './quickbooks-modal/QuickBooksModal';
import { pushEventInfo } from '../../../utils/analytics';

const paragraph1 = () => (
  <span>
    Sync your Home Depot transactions with QuickBooks Online and QuickBooks
    Desktop.
  </span>
);

const paragraph2 = () => (
  <p>
    <b>QuickBooks Online</b> <br /> Export summary and detailed transaction data
    for all of your Home Depot purchases. These transactions will include
    &quot;Home Depot- QuickBooks Purchases&quot; as their associated credit
    card. <b>Note</b> that the export feature only supports exports of up to 390
    transactions at a time.
  </p>
);
const paragraph3 = () => (
  <p>
    <b>QuickBooks Desktop</b> <br /> Exporting to QuickBooks Desktop involves a
    couple more steps. The tutorial in the next section will walk through what
    those include. As with QuickBooks Online, your transactions will export with
    The Home Depot as the vendor and &quot;Home Depot QuickBooks Purchases&quot;
    as their associated credit card.
  </p>
);

export const QuickBooksButton = ({
  request,
  setAlertState,
}: {
  request: IPHRequest;
  setAlertState: (value: IAlert | null) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [openModal, setOpenModal] = useState(false);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="sui-flex sui-items-center">
      <img
        src="https://assets.thdstatic.com/images/v1/QBIcon.svg"
        alt="Quick Books Icon"
        width="25px"
        height="25px"
      />
      <button
        data-testid="quickbooks-export-button"
        type="button"
        className="sui-underline"
        onClick={() => {
          pushEventInfo({
            category: { primaryCategory: 'button submission' },
            eventInfo: { eventName: 'my account settings' },
            myAccount: { settings: 'purchase history: quickbooks export' },
          });
          setOpenModal(true);
        }}
      >
        Quick Books Exports
      </button>
      <button
        data-testid="quickbooks-export-info-button"
        type="button"
        onClick={handleClick}
        style={{ paddingTop: 5, paddingLeft: 5 }}
      >
        <InfoFilled color="subtle" size="small" />{' '}
      </button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        placement="bottom"
        title="Add Purchases to QuickBooks"
        style={{ zIndex: 1000 }} // temp fix until stencil team fixes issue.
      >
        <div
          className="quickbooks-export-info"
          data-testid="quickbooksExportInfo"
        >
          <div className="quickbooks-export-info__paragraph">
            {paragraph1()}
            <br />
            <br />
            {paragraph2()}
            <br />
            {paragraph3()}
          </div>
        </div>
      </Popover>
      <QuickBooksModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        request={request}
        setAlertState={setAlertState}
      />
    </div>
  );
};
